var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PowerBiEmbed',{attrs:{"report-id":_vm.report.id,"type":"report","config":_vm.config},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var print = ref.print;
var displayFullscreen = ref.displayFullscreen;
return [_c('EmbedHeader',_vm._g({attrs:{"name":_vm.report.name},on:{"print":print,"fullscreen":displayFullscreen,"back-to-workspace":function($event){return _vm.$router.push({name: 'workspace'})}}},_vm.$route.query.fromDashboard ? {
        'back-to-dashboard': function () { return _vm.backToDashboard(_vm.$route.query.fromDashboard); }
      } : {}))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }